var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'tva-simple-button',
    _vm.config.buttonType,
    { active: _vm.active },
    { 'only-icon': !_vm.content },
    { 'with-icon': _vm.content && _vm.config.icon }
  ],on:{"click":function($event){_vm.active = !_vm.active}}},[(_vm.content)?_c('span',[_vm._v(_vm._s(_vm.content))]):_vm._e(),(_vm.config.icon)?_c('svgicon',{class:['tva-simple-button-icon'],attrs:{"icon":"actions-navigation-add","width":"20","height":"20"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }